import { MarketFeeModeEnum } from '@talos/kyoko';

export const DEALER_FEE_MODE_OPTIONS: MarketFeeModeEnum[] = [
  MarketFeeModeEnum.SpecificCurrency,
  MarketFeeModeEnum.QuoteCurrency,
  MarketFeeModeEnum.ReceiveCurrency,
  MarketFeeModeEnum.AmountCurrency,
];
